import React from "react";
import classNames from "classnames";
import Icon from "../../Icon/Icon";

import chatIcon from "icons/chat-button.svg";


class ChatButton extends React.PureComponent {
  render() {
    const { hidden, ...rest } = this.props;
    const buttonClasses = classNames(
      "chat-button",
      { "is-hidden": hidden }
    );
    
    return (
      <div className={ buttonClasses } { ...rest }>
        <Icon glyph={ chatIcon }/>
      </div>
    );
  }
}

export default ChatButton;


// WEBPACK FOOTER //
// ./app/components/Chat/ChatButton/ChatButton.jsx